import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AccountView from '../views/AccountView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Notas' },
  },
  {
    path: '/invite/:token',
    name: 'invite',
    component: HomeView,
    meta: { title: 'Aceptar invitación' },
  },
  {
    path: '/cuenta',
    name: 'account',
    component: AccountView,
    meta: { title: 'Mi cuenta' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta?.title || 'Notas';
});

export default router;
